<template>
  <div id="discount__setup">
    <vs-card>
      <!-- system dicount and taxes -->
      <div class="grid grid-cols-2 gap-4 mt-5">
        <div class="text-center">
          <h1>Discount</h1>
        </div>
        <div class="text-center">
          <h1>Tax Exemptions</h1>
        </div>
        <div></div>
        <div class="flex items-center justify-evenly mt-5">
          <label for="" class="font-bold">City</label>
          <label for="" class="font-bold">State</label>
          <label for="" class="font-bold">County</label>
        </div>
      </div>
      <div class="grid grid-cols-2" :key="keys" v-for="(values, keys) of systemDiscountAndTax">
        <div class="border-right">
          <div class="flex items-center justify-between mt-5 mx-48">
            <div class="grid grid-cols-2 gap-4 mx-auto">
              <div>
                <label for="" class="font-bold mr-2">{{ values.name }}</label>
              </div>
              <div>
                <vs-input
                  icon="icon icon-percent"
                  type="number"
                  step="0.01"
                  @input="(item) => setState({ action: `systemDiscountAndTax[${keys}].value`, data: item })"
                  :value="values.value"
                  icon-pack="feather"
                  icon-after="true"
                  class="w-full"
                  name="Veteran"
                  max-number="100"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('Veteran')">{{ errors.first('Veteran') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="flex items-center justify-evenly mt-3">
            <vs-checkbox class="mt-4" color="primary" @input="(item) => setState({ action: `systemDiscountAndTax[${keys}].city_tax`, data: item })" :value="values.city_tax"></vs-checkbox>
            <vs-checkbox class="mt-4" color="primary" @input="(item) => setState({ action: `systemDiscountAndTax[${keys}].state_tax`, data: item })" :value="values.state_tax"></vs-checkbox>
            <vs-checkbox class="mt-4" color="primary" @input="(item) => setState({ action: `systemDiscountAndTax[${keys}].county_tax`, data: item })" :value="values.county_tax"></vs-checkbox>
          </div>
        </div>
      </div>
      <div class="text-center mt-5 pb-5">
        <vs-button class="mr-2 vs-con-loading__container" id="save-system-discount-set-up" @click="saveSystemDiscountAndTax()" :disabled="loading" type="relief">Save Discount/Tax</vs-button>
      </div>
    </vs-card>
    <vs-card class="mt-5">
      <!-- user own tax and discounts -->
      <div class="pb-5 mt-5">
        <h1 class="text-center mb-5">Create Your Own Discounts</h1>
        <add-discount-set-up @tax-and-discount-added="handleTaxAndDiscountAdded" />
      </div>
    </vs-card>
    <hr class="mx-auto text-center border-black bg-black" />
    <vs-card class="mt-5">
      <!-- user own tax and discount list -->
      <div class="mt-5">
        <h1 class="text-center mb-5">Your Own Discounts</h1>
        <user-own-discount-list ref="tax-and-discont-table" />
      </div>
    </vs-card>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import AddDiscountSetUp from './components/AddDiscountSetUp.vue'
import UserOwnDiscountList from './components/UserOwnDiscountList.vue'

export default {
  name: 'DiscountSetup',

  components: {
    AddDiscountSetUp,
    UserOwnDiscountList
  },

  data() {
    return {
      form: {}
    }
  },
  mounted() {
    this.findSystemDiscountAndTax()
  },

  computed: {
    ...mapState('setting', ['loading', 'systemDiscountAndTax'])
  },

  methods: {
    ...mapMutations('setting', { setState: 'SET_STATE' }),
    ...mapActions('setting', ['insertDiscountAndTaxSetUp', 'getSystemDiscountAndTax', 'addOrUpdateSystemDiscountAndTaxSetup']),
    async findSystemDiscountAndTax() {
      const payload = { page: 1, limit: 0, search: null, order: ['tax_and_discount.id', 'ASC'], type: ['system'] }
      await this.getSystemDiscountAndTax(payload)
    },
    async saveSystemDiscountAndTax() {
      const { message } = await this.addOrUpdateSystemDiscountAndTaxSetup({ items: this.systemDiscountAndTax })
      // this.$router.push({ name: 'product-list' })
      this.$vs.notify({
        title: 'Success',
        text: message,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
    },
    handleTaxAndDiscountAdded() {
      this.$refs['tax-and-discont-table'].findSystemDiscountAndTax()
    }
  },
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#discount__setup',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#discount__setup > .con-vs-loading')
      }
    },

    // callback handle - add  customer status modal
    isAddClientStatusModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.AddClientStatusModalMounted = false
          }, 0)
        }
      }
    },

    //callback handle - update customer status modal
    isUpdatedClientStatusModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isUpdatedClientStatusModalMounted = false
          }, 0)
        }
      }
    },

    // callback handle - add promo discount modal
    isAddPromoDiscountModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddPromoDiscountModalMounted = false
          }, 0)
        }
      }
    },
    //callback handle - update promo discount modal
    isUpdatedPromoDiscountModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isUpdatedPromoDiscountModalMounted = false
          }, 0)
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.isAddClientStatusModalShow = false
    this.isUpdatedClientStatusModalShow = false
    this.isAddPromoDiscountModalShow = false
    this.isUpdatedPromoDiscountModalShow = false

    next()
  }
}
</script>

<style scoped>
.border-right {
  border-right: 2px solid black;
}

.border-bottom {
  border-bottom: 2px solid black;
}
</style>
